import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.document.getElementById('appFavicon').setAttribute('href', 'assets/favicons/prod-favicon.png');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

